import {MaterialTransaction} from '../../../../../envisia/material/material-management.model';
import {EnvisiaObjects, Lister} from '../../../../../common/wrapper.models';
import {useSuspenseQuery} from '@tanstack/react-query';
import {AxiosHttpClient} from '../../../../../envisia/auth/axios-http-client';
import {environment} from '../../../../../../environments/environment';
import {queryParamsArray} from '../../../../helper/url-search-params/queryParamsArray';
import {ProductionMachine} from '../../../../production/machines/production-machine.model';
import {queryKey} from '../../../../production/machines/production-machine-query-keys';

export function useMaterialTransactionHistoryMachineListQuery(
  transaction: MaterialTransaction,
): EnvisiaObjects<ProductionMachine> {
  const params = queryParamsArray('ids', transaction.production_machine_ids.map(id => `${id}`));
  const {data} = useSuspenseQuery({
    queryKey: queryKey.listByIds(params),
    queryFn: () => AxiosHttpClient.get<Lister<ProductionMachine>>(
      `${environment.apiv4uri}production/machines/ids`,
      params,
    ),
  });
  return data;
}
